module.exports = __webpack_public_path__ + "img/@tmp_facility_01.223ac9b5.jpg";